/* Dirksen Scooters — collectiepagina
   Vanilla JS, defer geladen. Het formulier werkt zonder dit script; hier wordt
   alleen het herladen van de hele pagina vervangen door het hertekenen van de
   sectie via de Section Rendering API.

   Op mobiel staan de filters in een lade. Daar wordt niet automatisch
   toegepast: de knop "Toon resultaten" dient het formulier gewoon in. Dat scheelt
   verrassingen tijdens het aanvinken en voorkomt dat de lade onder de gebruiker
   vandaan hertekend wordt. */

(function () {
  'use strict';

  function mediaQuery(query) {
    if (!window.matchMedia) {
      return { matches: false, addEventListener: function () {} };
    }
    return window.matchMedia(query);
  }

  function claim(el) {
    // Zelfde bescherming als in dirksen-home.js: één opzet per element.
    if (el.dataset.dkReady === '1') return false;
    el.dataset.dkReady = '1';
    return true;
  }

  function setup(root) {
    if (!claim(root)) return;
    var sectionId = root.dataset.dkSection;
    if (!sectionId) return;

    var wide = mediaQuery('(min-width: 768px)');
    var busy = false;
    // Uitgeklapte filterlijsten, op id. Blijven open als de sectie na het
    // filteren opnieuw getekend wordt.
    var expanded = {};

    function setExpanded(button, open) {
      var list = document.getElementById(button.getAttribute('aria-controls'));
      if (!list) return;
      list.classList.toggle('is-expanded', open);
      button.setAttribute('aria-expanded', open ? 'true' : 'false');
      button.textContent = open ? button.dataset.dkLessLabel : button.dataset.dkMoreLabel;
    }

    function restoreExpanded() {
      Array.prototype.forEach.call(root.querySelectorAll('[data-dk-more]'), function (button) {
        if (expanded[button.getAttribute('aria-controls')]) setExpanded(button, true);
      });
    }

    function sectionUrl(url) {
      var separator = url.indexOf('?') === -1 ? '?' : '&';
      return url + separator + 'section_id=' + encodeURIComponent(sectionId);
    }

    function render(url, options) {
      if (busy) return;
      busy = true;
      root.setAttribute('aria-busy', 'true');

      fetch(sectionUrl(url))
        .then(function (response) {
          if (!response.ok) throw new Error('sectie kon niet geladen worden');
          return response.text();
        })
        .then(function (html) {
          var parsed = new DOMParser().parseFromString(html, 'text/html');
          var fresh = parsed.querySelector('[data-dk-collection]');
          if (!fresh) throw new Error('sectie niet gevonden in het antwoord');

          root.innerHTML = fresh.innerHTML;
          restoreExpanded();

          if (options && options.push !== false) {
            window.history.pushState({ dkCollection: true }, '', url);
          }
          if (options && options.scroll) {
            var top = root.getBoundingClientRect().top + window.pageYOffset;
            window.scrollTo({ top: top - 16, behavior: 'smooth' });
          }
        })
        .catch(function () {
          // Bij twijfel gewoon navigeren; filteren mag nooit stukgaan.
          window.location.href = url;
        })
        .then(function () {
          busy = false;
          root.removeAttribute('aria-busy');
        });
    }

    function urlFromForm(form) {
      var params = [];
      var elements = form.querySelectorAll('input, select');

      Array.prototype.forEach.call(elements, function (field) {
        if (!field.name) return;
        if (field.type === 'checkbox' || field.type === 'radio') {
          if (!field.checked) return;
        }
        if (field.value === '') return;
        params.push(encodeURIComponent(field.name) + '=' + encodeURIComponent(field.value));
      });

      var action = form.getAttribute('action') || window.location.pathname;
      return params.length ? action + '?' + params.join('&') : action;
    }

    root.addEventListener('change', function (event) {
      var sortForm = event.target.closest('[data-dk-sort]');
      if (sortForm) {
        render(urlFromForm(sortForm), { scroll: true });
        return;
      }

      var facetForm = event.target.closest('[data-dk-facets]');
      // Ander merk gekozen: de modellen van het vorige merk gaan uit.
      if (facetForm && event.target.type === 'radio' && event.target.name === 'filter.p.vendor') {
        Array.prototype.forEach.call(facetForm.querySelectorAll('input[name="filter.p.m.shop.model"]'), function (box) {
          box.checked = false;
        });
      }
      if (facetForm && wide.matches) {
        // In de lade op mobiel gebeurt er niets tot op de knop getikt wordt.
        render(urlFromForm(facetForm), { scroll: false });
      }
    });

    root.addEventListener('submit', function (event) {
      var facetForm = event.target.closest('[data-dk-facets]');
      if (facetForm && wide.matches) {
        event.preventDefault();
        render(urlFromForm(facetForm), { scroll: false });
      }
    });

    root.addEventListener('click', function (event) {
      var more = event.target.closest('[data-dk-more]');
      if (more) {
        var open = more.getAttribute('aria-expanded') !== 'true';
        expanded[more.getAttribute('aria-controls')] = open;
        setExpanded(more, open);
        return;
      }

      var link = event.target.closest('.dk-chip, .dk-chips__clear, .dk-finder__chip, .dk-pager__page, .dk-pager__step');
      if (!link || !link.href) return;
      event.preventDefault();
      render(link.href, { scroll: true });
    });

    window.addEventListener('popstate', function () {
      render(window.location.href, { push: false, scroll: false });
    });
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-dk-collection]'), setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-dk-collection]');
    if (root) setup(root);
  });
})();
